// extracted by mini-css-extract-plugin
export default {"Container":"Layout_Container__Qaa0Q","Main":"Layout_Main__zh21a"};